import { IUser, User } from 'src/app/core/user/user.model';
import { BankInfo, IBankInfo } from 'src/app/shared/model/bank-info.model';
import { ContactDetailDTO, IContactDetailDTO } from 'src/app/shared/model/contact-details-dto.model';
import { AddressMySuffix, IAddressMySuffix } from './address-my-suffix.model';
import { FinscanOpportunityDto, IFinscanOpportunityDto } from './fin-scan-opportunities.model';
import { FinscanSanctionListsDto, IFinscanSanctionListsDto } from './finscan-sanction-list.model';
import { IQuickLinksPermissionDto, QuickLinksPermissionDto } from './quick-links-permission-dto.model';


export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export const enum TypeOfBrokerUser {
    INDIVIDUAL = 'INDIVIDUAL',
    COMPANY = 'COMPANY'
}

export const enum Accessibility {
    FULL_ACCESS = 'FULL_ACCESS',
    PROVISIONAL_ACCESS = 'PROVISIONAL_ACCESS'
}

export interface IBrokerDTO {
    id?: number;
    activeStatus?: ActiveStatus;
    accessibility?: any;
    userDTO?: IUser;
    typeOfBrokerUser?: TypeOfBrokerUser;
    typeOfUnderwriterUser?: TypeOfBrokerUser;
    typeOfInsurerUser?: TypeOfBrokerUser;
    bankInfos?: IBankInfo[];
    companyName?: string;
    contactDetails?: IContactDetailDTO[];
    laguagesKnown?: string;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    lcApproval?: boolean;
    automaticQuotation?: boolean;
    isVoyageNumberRequired?: boolean;
    fromEffectiveDate?: string;
    enablePremiumCalculation?: boolean;
    enableAccounting?: boolean;
    enableVesselScreening?: boolean;
    quickLinksPermissionDTOS?: IQuickLinksPermissionDto;
    enableSanctionsScreening?: boolean;
    finscanOpportunities?: IFinscanOpportunityDto[];
    finscanSanctionLists?: IFinscanSanctionListsDto[];
    isForReplace?: boolean;
    website?: string;
    assignedBrokerAddress?: IAddressMySuffix; // used in view
    quickLinksPermissions?: IQuickLinksPermissionDto;
    enableStandardSurvey?: boolean;
    displayName?: string;
    uniqueId?: string;
    userRole?: string;
    user?: IUser;
    userStatus?: string;
    enableEsgCarboncare?: boolean;
    enableEsgAwareness?: boolean;
    enableEsgComparison?: boolean;
    isVesselNameOrImoMandatory?: boolean;
    enableMovers?: boolean;
}

export class BrokerDTO implements IBrokerDTO {
    constructor(
        public id?: number,
        public activeStatus?: ActiveStatus,
        public accessibility?: Accessibility,
        public userDTO = new User(),
        public typeOfBrokerUser?: TypeOfBrokerUser,
        public typeOfUnderwriterUser?: TypeOfBrokerUser,
        public typeOfInsurerUser?: TypeOfBrokerUser,
        public bankInfos: IBankInfo[] = [],
        public companyName?: string,
        public contactDetails: IContactDetailDTO[] = [],
        public laguagesKnown?: string,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public lcApproval?: boolean,
        public automaticQuotation?: boolean,
        public isVoyageNumberRequired?: boolean,
        public fromEffectiveDate?: string,
        public enablePremiumCalculation?: boolean,
        public enableAccounting?: boolean,
        public quickLinksPermissionDTOS = new QuickLinksPermissionDto(),
        public enableSanctionsScreening?: boolean,
        public finscanOpportunities: IFinscanOpportunityDto[] = [],
        public finscanSanctionLists: IFinscanSanctionListsDto[] = [],
        public enableVesselScreening?: boolean,
        public displayName?: string,
        public user?: IUser,
        public isForReplace?: boolean,
        public website?: string,
        public assignedBrokerAddress?: IAddressMySuffix, // used in view
        public quickLinksPermissions?: IQuickLinksPermissionDto,
        public uniqueId?: string,
        public userStatus?: string,
        public enableStandardSurvey?: boolean,
        public enableEsgCarboncare?: boolean,
        public enableEsgAwareness?: boolean,
        public enableEsgComparison?: boolean,
        public isVesselNameOrImoMandatory?: boolean,
        public enableMovers?: boolean,
        public enablePoliticalRisk?: boolean

    ) {
        let dto = new ContactDetailDTO();
        this.contactDetails.push(dto);
        let bankDetials = new BankInfo();
        this.bankInfos.push(bankDetials);
        this.activeStatus = ActiveStatus.ACTIVE;
        this.lcApproval = false;
        this.automaticQuotation = false;
        this.isVoyageNumberRequired = false;
        this.enableSanctionsScreening = false;
        this.enableEsgCarboncare = false;
        let finScanDetails = new FinscanOpportunityDto();
        this.finscanOpportunities.push(finScanDetails);
        let finsacnSanctionListDetails = new FinscanSanctionListsDto();
        this.finscanSanctionLists.push(finsacnSanctionListDetails)
        this.user = new User();
        this.isForReplace = false;
        this.assignedBrokerAddress = new AddressMySuffix();
    }

    setBrokerDataForAssigned(id?: number, name?: string, displayName?: string) {
        this.id = id;
        this.companyName = name;
        this.displayName = displayName
    }
}
